/**
 * Self-hosted implementation of EmailAdapter.
 * Calls a direct /email/send REST endpoint on the self-hosted backend,
 * which can relay to Resend, SMTP, or any other mail provider.
 */

import type { EmailAdapter, EmailPayload, EmailResult } from '../interfaces';

const BASE = () =>
  process.env.NEXT_PUBLIC_SELF_HOSTED_API_URL ?? 'http://localhost:4000';

function getToken(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem('nexus_access_token');
}

export class SelfHostedEmailAdapter implements EmailAdapter {
  async sendAlert(payload: EmailPayload): Promise<EmailResult> {
    try {
      const token = getToken();
      const res = await fetch(`${BASE()}/email/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ type: payload.type, to: payload.to, data: payload.data }),
      });

      if (!res.ok) {
        const msg = await res.text().catch(() => res.statusText);
        console.error('[SelfHostedEmail] sendAlert:', msg);
        return { success: false, error: msg };
      }

      return { success: true };
    } catch (e: any) {
      console.error('[SelfHostedEmail] sendAlert exception:', e.message);
      return { success: false, error: e.message };
    }
  }
}
